import PropTypes from "prop-types"
import { connect } from "react-redux"

import Media from "components/ui/media"

import AddonDesktopItem from "./addon-desktop-item"

const InternalAddon = ({
  addons,
  deleteExclusiveAddon,
  exclusiveAddonsRef,
}) => {
  if (addons.length === 0) return null

  return (
    <Media greaterThanOrEqual="tablet">
      <div className="flex flex-col gap-16" ref={exclusiveAddonsRef}>
        {addons.length > 0 &&
          addons.map((addon, index) => (
            <AddonDesktopItem
              addon={addon}
              data-cy={`cart-addon-desktop-${index}-${addon.addon_code}`}
              data-ge-basket-cartitemid={addon.id}
              deleteExclusiveAddon={deleteExclusiveAddon}
              id={"addon_item_" + addon.id}
              index={index}
              key={`d_addon-${addon.id}`}
            />
          ))}
      </div>
    </Media>
  )
}

const mapStateToProps = (state) => {
  return {
    addons: state.cart.addons.filter(
      (a) => a.addon_type === "BUNDLE" || a.addon_type === "GIFT_CARD"
    ),
  }
}

const mapDispatchToProps = () => {
  return {}
}

InternalAddon.propTypes = {
  addons: PropTypes.array,
  deleteExclusiveAddon: PropTypes.func,
  exclusiveAddonsRef: PropTypes.func,
}

const Addon = connect(mapStateToProps, mapDispatchToProps)(InternalAddon)

export default Addon
